import { just, Maybe } from 'maybeasy';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Typography } from '../../components/UI';
import { findLinkBy } from '../../Links';
import { AlreadyTranslated, AlreadyTranslatedText, T } from '../../Translations';
import CollectionLogo from './Common/CollectionLogo';
import { HtmlView } from './Common/Experience';
import { SharedInvitationResource } from './SharedOpenEnrollment/SharedInvitationResourceStore/Types';

interface TitleAndDescription {
  title: React.ReactElement;
  content: React.ReactElement;
}

interface Props {
  sharedInvitationResource: SharedInvitationResource;
}

const RegistrationHeaderTitleAndDescription: React.FC<Props> = ({ sharedInvitationResource }) => {
  const { loginMessage, loginMessageType, description, name, organization } =
    sharedInvitationResource.payload;

  const { links } = sharedInvitationResource;

  const logoLink = findLinkBy({ rel: 'learning-collection-logo' }, links);

  const message = (): Maybe<AlreadyTranslatedText> => {
    switch (loginMessageType) {
      case 'use-case-login-message':
        return loginMessage;
      case 'use-case-description':
        return description;
    }
  };

  const { title, content }: TitleAndDescription = just({})
    .assign('content', message)
    .assign('title', name)
    .map(({ content, title }) => ({
      title: <AlreadyTranslated content={title} />,
      content: (
        <div className="container box-border w-full items-center justify-between">
          <div className="flex flex-col md:flex-row md:gap-20">
            <div className="w-full justify-center">
              <HtmlView description={content} />
            </div>
            <CollectionLogo link={logoLink} />
          </div>
        </div>
      ),
    }))
    .getOrElse(() => ({
      title: <T kind="Get ready to grow with ExecOnline" />,
      content: (
        <Typography>
          <T
            kind="{{orgName}} is partnering with ExecOnline to provide highly actionable ..."
            orgName={organization.payload.name}
          />
        </Typography>
      ),
    }));

  return (
    <>
      <Typography className="mb-4" variant="h3" component="h1" fontWeight="medium">
        {title}
      </Typography>
      <div className="mb-4">{content}</div>
    </>
  );
};

export default observer(RegistrationHeaderTitleAndDescription);
